/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';
import componentSelectionMethods from '#constants/models/componentSelectionMethods.js';

const items = componentSelectionMethods.map(m => ({
  id: m.id,
  name: m.name,
  value: m.id,
}));

type Props = {|
  form: string,
  name: string,
|};

const ComponentPopulationMethodSelectMenu = ({ form, name }: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items}
    id={name}
    name={name}
    inputClassName={classNames('custom-select', 'component-population-method-select')}
    includeEmptyOption={false}
  />
);

export default ComponentPopulationMethodSelectMenu;
